import * as React from 'react';
import { Package } from 'lucide-react';
import { Pack } from '../../types/landing';
import { Slider } from './Slider';
import { PackCard } from './PackCard';
import { route } from '../../utils/route';

interface PacksSliderProps {
  packs: Pack[];
}

export function PacksSlider({ packs }: PacksSliderProps): React.ReactElement {
  return (
    <div className="packs-slider-wrapper">
      <style>{`
        .packs-slider-wrapper {
          background: #f8f9fa;
        }

        .packs-slider-wrapper .slider-section {
          background: transparent;
        }
      `}</style>

      <Slider
        title="Nuestras Selecciones"
        shortTitle="Selecciones"
        icon={<Package size={24} />}
        viewAllLink={route('packs.index')}
        viewAllText="Ver todos los packs"
      >
        {packs.map(pack => (
          <PackCard
            key={pack.id}
            pack={pack}
          />
        ))}
      </Slider>
      <p className="mx-auto max-w-6xl px-5 pb-8 text-sm">
        <a href="/bolson-de-verduras" className="font-semibold text-green-700 underline hover:text-green-800">
          Bolsón de verduras: qué trae, cuánto dura y cuánto sale puesto en casa
        </a>
      </p>
    </div>
  );
}
